/**
 * TicketChat - Chat component for ticket detail page in Portal
 * 
 * Now uses the shared @crm/chat package for unified UI.
 */
import { ChatPanel } from "@crm/chat";

interface TicketChatProps {
  ticketId: string;
  isResolved?: boolean;
  className?: string;
  defaultExpanded?: boolean;
}

export function TicketChat({ 
  ticketId, 
  isResolved = false,
  className,
  defaultExpanded = true 
}: TicketChatProps) {
  return (
    <ChatPanel
      ticketId={ticketId}
      isResolved={isResolved}
      className={className}
      collapsible={false}
      defaultExpanded={defaultExpanded}
    />
  );
}
